import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { removeStorageItem } from "../../helpers/index";

class Logout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onClickLogOut = () => {
    let accessToken = removeStorageItem("accessToken");
    removeStorageItem("feathers-jwt");
    removeStorageItem("userData");

    if (!accessToken) {
      window.location.reload();
      this.props.history.push("/");
    }
  };

  render() {
    return (
      <div className="reveal" id="logoutModal" data-reveal>
        <h1>Awesome. I Have It.</h1>
        <p className="lead">Your couch. It is mine.</p>
        <p>
          I'm a cool paragraph that lives inside of an even cooler modal. Wins!
        </p>
        <button
          className="close-button"
          data-close
          aria-label="Close modal"
          type="button"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      /* <div
        className="modal fade"
        id="logoutModal"
        tabIndex="-1"
        aria-labelledby="logoutModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Logout</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure want to logout?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => this.onClickLogOut()}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div> */
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Logout));
